import { render, staticRenderFns } from "./CustomerTableAddress.vue?vue&type=template&id=51a1a835"
import script from "./CustomerTableAddress.vue?vue&type=script&lang=js"
export * from "./CustomerTableAddress.vue?vue&type=script&lang=js"
import style0 from "./CustomerTableAddress.vue?vue&type=style&index=0&id=51a1a835&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports